import { createRouter, createWebHistory } from "vue-router";
import { inject } from "vue";
import routes from "./routes";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...routes,
        {
            path: "/:pathMatch(.*)*",
            component: () => import("@/pages/NotFoundPage.vue"),
        },
    ],
});

router.beforeEach((to, from, next) => {
    const store = inject("store");
    if (to.meta.requiresRole && !to.meta.requiresRole.some(role => store.authModule.getters.hasRole(role))) {
        next("/");
    } else {
        next();
    }
});

export default router;
